<template>
  <router-link :to="to ? to : ''" class="button__wrapper" @click="handleClick">
    <div class="d-flex justify-content-between">
        <span class="back-icon">
          <i class="fas fa-arrow-left text-white"></i>
        </span>
      <div>
        <slot></slot>
      </div>
    </div>
  </router-link>
</template>
<script>
  export default {
    name: 'nav-back-button',
    props: {
      to: [String, Object]
    },
    methods: {
      handleClick () {
        if (this.to) {
          this.$router.push(this.to)
        } else {
          this.$router.go(-1)
        }
        this.$emit('click')
      }
    }
  }
</script>
<style lang="scss" scoped>
  .back-icon {
    width: 18px;
    height: 18px;
    background-color: $secondary-dark;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 25px;
    i {
      font-size: 12px;
    }
  }

  .button__wrapper {
    color: $default-color;
    background-color: transparent;
    border: none transparent;
    height: 36px;
    padding: 0 8px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    font-weight: 700;
  }

  .button__wrapper:hover {
    color: $secondary-dark;
    font-weight: bold;
    background-color: $secondary-light;
    border-radius: $border-radius-base;
  }
</style>
